export default {
  pt_br: {
    controls: {
      play: 'Reproduzir',
      pause: 'Pausar',
      share: 'Compartilhar',
      language: 'Idioma',
      settings: 'Configurações',
      fullscreen: 'Tela inteira',
      rewind: 'Retroceder',
      forward: 'Avançar',
      vrStereo: 'vrStereo',
      live: 'Ao vivo',
      mute: 'Sem áudio',
      unmute: 'Ativar som',
      next: 'Próximo',
      prev: 'Anterior',
      startOver: 'Começar de novo',
      pictureInPicture: 'Picture in picture',
      logo: 'Logo',
      seekBarSlider: 'Controle deslizante',
    },
    unmute: {
      unmute: 'Ativar som',
    },
    copy: {
      button: 'Copiar URL',
    },
    settings: {
      title: 'Configurações',
      quality: 'Qualidade',
      speed: 'Velocidade',
      speedNormal: 'Normal',
    },
    language: {
      title: 'Idioma',
      audio: 'Áudio',
      captions: 'Legendas',
      advanced_captions_settings: 'Configurações avançadas de legendas',
    },
    share: {
      title: 'Compartilhar',
      embed_options: 'Opções de incorporação',
      start_video_at: 'Começar vídeo em',
      email: 'Compartilhar no e-mail',
      embed: 'Obter código incorporado',
    },
    overlay: {
      close: 'Fechar',
    },
    error: {
      default_error: 'Ocorreu um erro',
      default_session_text: 'ID da sessão',
      retry: 'Tentar Novamente',
    },
    ads: {
      ad_notice: 'Publicidade',
      learn_more: 'Saiba mais',
      skip_ad: 'Ignorar publicidade',
      skip_in: 'Ignorar em',
    },
    cvaa: {
      title: 'Configurações avançadas de legendas',
      sample_caption_tag: 'Amostra',
      sample_custom_caption_tag: 'Legendas personalizadas',
      set_custom_caption: 'Definir legenda personalizada',
      edit_caption: 'Editar legenda',
      size_label: 'Tamanho',
      font_color_label: 'Cor da fonte',
      font_family_label: 'Família da fonte',
      font_style_label: 'Estilo da fonte',
      font_opacity_label: 'Opacidade da fonte',
      background_color_label: 'Cor de fundo',
      background_opacity_label: 'Opacidade do fundo',
      apply: 'Aplicar',
      caption_preview: 'Esta é a pré-visualização da sua legenda',
    },
    cast: {
      play_on_tv: 'Reproduzir na TV',
      disconnect_from_tv: 'Desconectar da TV',
      status: {
        connecting_to: 'Conectando a',
        connected_to: 'Conectado a',
        playing_on: 'Reproduzindo em',
      },
    },
    playlist: {
      prev: 'Anterior',
      next: 'Próximo',
      up_next: 'A seguir',
      cancel: 'Cancelar',
    },
    pictureInPicture: {
      overlay_text: 'Reproduzindo no modo Picture In Picture',
    },
  },
};
